<template>
  <div class="wrapper">
    <div class="bpa-field-main-col el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-24 el-col-lg-24 el-col-xl-24">
      <div class="bpa-bdf--single-col-item">
        <div class="el-form-item" :class="required ? 'is-required' : ''"><label v-if="label" :for="name"
            class="el-form-item__label"><span class="bpa-front-form-label">{{ label }}</span></label>
          <div class="el-form-item__content">
            <div class="bpa-front-form-control el-input">
              <div class="flex items-center space-x-2">
                <select v-model="selectedCountry" class="border rounded px-2 py-1" @blur="setTouched(true)">
                  <option v-for="(country, code) in countries" :key="code" :value="code">
                    {{ country.flag }} {{ code }}
                  </option>
                </select>&nbsp;
                <input type="text" v-model="vatNumber" @input="formatVat" class="flex-1 border rounded px-2 py-1" :class="{ field_error: errorMessage, valid: meta.valid }"
                  :placeholder="placeholder" @blur="setTouched(true)" />
              </div>
              <small :class="errorMessage ? 'error_message' : ''">{{ errorMessage }}</small>
            </div>
          </div>
        </div> <!---->
      </div> <!----> <!---->
    </div>
  </div>
</template>

<script setup>
import { useField } from 'vee-validate'
import debounce from 'lodash/debounce'
import { ref, computed, watch } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  type: String,
  placeholder: String,
  label: String,
  required: {
    type: Boolean,
    default: false
  }
})

const { value, errorMessage, setTouched, meta, setValue, handleChange } = useField(() => props.name)
const vatNumber = ref('')
const selectedCountry = ref('BE')
const localModel = ref(value.value)

watch([selectedCountry, vatNumber], () => {
  localModel.value = `${selectedCountry.value}${vatNumber.value}`.toUpperCase();
  // setValue(`${selectedCountry.value}${vatNumber.value}`);
})

const debouncedUpdate = debounce(val => {
  handleChange(val)
}, 500);

watch(localModel, (val) => {
  debouncedUpdate(val)
});

const countries = {
  AT: { name: 'Austria', flag: '🇦🇹', regex: /^ATU\d{8}$/ },
  BE: { name: 'Belgium', flag: '🇧🇪', regex: /^BE0\d{9}$/ },
  BG: { name: 'Bulgaria', flag: '🇧🇬', regex: /^BG\d{9,10}$/ },
  CY: { name: 'Cyprus', flag: '🇨🇾', regex: /^CY\d{8}[A-Z]$/ },
  CZ: { name: 'Czech Republic', flag: '🇨🇿', regex: /^CZ\d{8,10}$/ },
  DE: { name: 'Germany', flag: '🇩🇪', regex: /^DE\d{9}$/ },
  DK: { name: 'Denmark', flag: '🇩🇰', regex: /^DK\d{8}$/ },
  EE: { name: 'Estonia', flag: '🇪🇪', regex: /^EE\d{9}$/ },
  EL: { name: 'Greece', flag: '🇬🇷', regex: /^EL\d{9}$/ },
  ES: { name: 'Spain', flag: '🇪🇸', regex: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/ },
  FI: { name: 'Finland', flag: '🇫🇮', regex: /^FI\d{8}$/ },
  FR: { name: 'France', flag: '🇫🇷', regex: /^FR[A-Z0-9]{2}\d{9}$/ },
  HR: { name: 'Croatia', flag: '🇭🇷', regex: /^HR\d{11}$/ },
  HU: { name: 'Hungary', flag: '🇭🇺', regex: /^HU\d{8}$/ },
  IE: { name: 'Ireland', flag: '🇮🇪', regex: /^IE\d{7}[A-W][A-I0-9]?$/ },
  IT: { name: 'Italy', flag: '🇮🇹', regex: /^IT\d{11}$/ },
  LT: { name: 'Lithuania', flag: '🇱🇹', regex: /^LT\d{9,12}$/ },
  LU: { name: 'Luxembourg', flag: '🇱🇺', regex: /^LU\d{8}$/ },
  LV: { name: 'Latvia', flag: '🇱🇻', regex: /^LV\d{11}$/ },
  MT: { name: 'Malta', flag: '🇲🇹', regex: /^MT\d{8}$/ },
  NL: { name: 'Netherlands', flag: '🇳🇱', regex: /^NL\d{9}B\d{2}$/ },
  PL: { name: 'Poland', flag: '🇵🇱', regex: /^PL\d{10}$/ },
  PT: { name: 'Portugal', flag: '🇵🇹', regex: /^PT\d{9}$/ },
  RO: { name: 'Romania', flag: '🇷🇴', regex: /^RO\d{2,10}$/ },
  SE: { name: 'Sweden', flag: '🇸🇪', regex: /^SE\d{12}$/ },
  SI: { name: 'Slovenia', flag: '🇸🇮', regex: /^SI\d{8}$/ },
  SK: { name: 'Slovakia', flag: '🇸🇰', regex: /^SK\d{10}$/ }
}

function formatVat() {
  vatNumber.value = vatNumber.value.toUpperCase().replace(/[^0-9]/g, '')
}
</script>

<style scoped>
.vat-input input,
.vat-input select {
  font-size: 1rem;
}

.wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  gap: 3px;
}

.error_message {
  color: red;
}

.field_error {
  border: 1px solid red !important;
}

.input {
  width: 100%;
  height: 30px;
  border-radius: 5px;
  padding: 10px;
  border: 0.5px solid gray;
}

.input:focus {
  outline: none;
}

.valid {
  border: 1px solid green !important;
}

label {
  font-size: 14px;
  font-weight: 600;
}

.flex {
  display: flex;
}

.flex-1 {
  flex-grow: 1;
}
</style>
